import { useQuery } from '@apollo/client/react'

import { gql } from '../../__generated__/graphql/catalog/gql'

/**
 * The embroidery copy that is authored in the CMS rather than the fixtures
 */
const EMBROIDERY_SITE_MESSAGES_QUERY = gql(`
  query GetEmbroiderySiteMessages {
    siteMessages(siteFixturesHandle: "default") {
      embroideryMessages {
        logoDigitizationWarning
        logoLearnMorelink
        logoColorSelectionTooltip
      }
    }
  }
`)

export type EmbroiderySiteMessages = {
  logoDigitizationWarning: string | undefined
  logoLearnMoreLink: string | undefined
  logoColorSelectionTooltip: string | undefined
}

export function useEmbroiderySiteMessages(): EmbroiderySiteMessages {
  const { data } = useQuery(EMBROIDERY_SITE_MESSAGES_QUERY)
  const messages = data?.siteMessages?.embroideryMessages

  return {
    logoDigitizationWarning: messages?.logoDigitizationWarning ?? undefined,
    logoLearnMoreLink: messages?.logoLearnMorelink ?? undefined,
    logoColorSelectionTooltip: messages?.logoColorSelectionTooltip ?? undefined,
  }
}
